import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const env = (import.meta as unknown as { env?: Record<string, string> }).env ?? {}

// For testing recording migration, force local Supabase
const url = env.VITE_SUPABASE_URL || 'http://localhost:54321'
const anonKey = env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'

declare global {
  interface Window {
    __supabase?: SupabaseClient
  }
}

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined'

export const supabase: SupabaseClient = isBrowser && window.__supabase 
  ? window.__supabase 
  : createClient(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
    db: { schema: 'public' },
    global: { headers: { 'X-Client-Info': 'vetscribe-react-app' } },
  })

// Only set on window if we're in a browser environment
if (isBrowser && !window.__supabase) {
  window.__supabase = supabase
} 